<template>
  <form @submit.prevent="handleSubmit()" class="regular-form">

    <!-- Otp -->
    <otp-field
      v-model="$attrs.user.otp"
      :error="$attrs.errors.user.otp"
    />

    <div class="form-group text-center">
      <input class="btn btn-primary btn-lg" type="submit" :value="submitLabel">
    </div>
  </form>
</template>

<script>
import otpField from '@/components/forms/privat_otp_auth/fields/Otp'

export default {
  name: 'privat-otp-auth-blank-form',
  inheritAttrs: false,
  props: {
    submitLabel: {
      type: String,
      default: 'Submit'
    }
  },
  components: {
    otpField
  },
  methods: {
    handleSubmit () {
      this.$emit('submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// PrivatOtpAuthBlankForm.vue?4cb498e8